module.exports = __webpack_public_path__ + "img/CCS1.75ce5da5.png";